import Step2 from './Step2';

export default {
  title: 'Current Area Use',
  component: Step2,
};
